import { defineStore } from 'pinia';
import { GET_BAR_CODE_IMAGE } from '~/types/actions';
import { SET_BAR_CODE_IMAGE } from '~/types/mutations';
import { httpUpdateAPIHeaders } from '~/utils/APIUtil';
import { generateLogin365FingerPrint } from '~/utils/PersistentLoginUtil';
import $http from '@vue-util/http';

const BAR_CODE_IMAGE_ENDPOINT = '/regsvc/registry/api/v1/barcode';

export const useBarcodeStore = defineStore('barcode', {
  state: () => ({
    barcodeImage: null,
  }),
  actions: {
    [SET_BAR_CODE_IMAGE](data) {
      this.barcodeImage = data;
    },
    async [GET_BAR_CODE_IMAGE](payload) {
      try {
        const login365FingerPrint = await generateLogin365FingerPrint();
        const response = await $http.post(`${BAR_CODE_IMAGE_ENDPOINT}`, payload, {
          headers: httpUpdateAPIHeaders(payload, login365FingerPrint),
        });
        const isError = response?.data?.errors || response?.data?.error;
        if (!isError) {
          this[SET_BAR_CODE_IMAGE](response);
        } else {
          this[SET_BAR_CODE_IMAGE](isError);
        }
      } catch {
        this[SET_BAR_CODE_IMAGE]('');
      }
    },
  },
});
